import { render, staticRenderFns } from "./MealItemForm.vue?vue&type=template&id=50c205b4&scoped=true"
import script from "./MealItemForm.vue?vue&type=script&lang=js"
export * from "./MealItemForm.vue?vue&type=script&lang=js"
import style0 from "./MealItemForm.vue?vue&type=style&index=0&id=50c205b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c205b4",
  null
  
)

export default component.exports